<template>
  <div class="todo-app">
    <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
      <li class="cursor-pointer todo_todo-item" v-for="(item, index) in data" :key="item.version" :style="[{transitionDelay: (index * 0.1) + 's'}]">
        <div class="px-4 py-4 list-item-component">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
              <div class="flex items-center">
                <h6  class="todo-title" >
                  v{{ item.version }}
                </h6>
               
              </div>
              <div  class="todo-tags sm:ml-2 sm:my-0 my-2 flex">
                {{ item.user }} - {{ item.time | toDateTime }}
              </div>
            </div>
            
            <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
              <feather-icon
                  icon="EyeIcon"
                  class="cursor-pointer"
                  svgClasses="w-5 h-5 mr-3"
                    v-b-tooltip.hover :title="$t('MRMR.Statement.ViewVersionTooltip')"
                  @click="onViewVersionClicked(item)" />              
              <feather-icon
                v-if="canPromoteVersion && item.version < data.length"
                icon="RotateCcwIcon"
                class="cursor-pointer"
                svgClasses="w-5 h-5 mr-3"
                v-b-tooltip.hover :title="$t('MRMR.Statement.PromoteVersionTooltip')"
                @click="onPromoteVersionClicked(item)" />
            </div>

          </div>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    canPromoteVersion() {
      return (this.$auth.isInRole("MRMRCollaborators") || this.$auth.isInRole("Admin")) && this.data.length > 1;
    }
  },
  methods: {
    onViewVersionClicked(item) {
      this.$emit("onViewVersion", item, item.version === this.data.length);
    },
    onPromoteVersionClicked(item) {
      this.$emit("onPromoteVersion", item);
    }
  }
}
</script>
<style  lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
  .vs-tooltip{
    z-index: 99999;
  }
</style>